import { render, staticRenderFns } from "./LeaveMessage.vue?vue&type=template&id=2a6e83f2&scoped=true&lang=true&"
import script from "./LeaveMessage.vue?vue&type=script&lang=js&"
export * from "./LeaveMessage.vue?vue&type=script&lang=js&"
import style0 from "./LeaveMessage.vue?vue&type=style&index=0&id=2a6e83f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6e83f2",
  null
  
)

export default component.exports